import GoogleMapReact from 'google-map-react';
import $ from 'jquery'; // <-to import jquery
import 'bootstrap';
import ReactDOM from 'react-dom';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { OverlayTrigger, Popover, Image, Container, Row, Col, Modal, Table } from 'react-bootstrap';
import { FilterContext } from "../context/FilterContext";
//import useGeolocation from 'react-hook-geolocation'
import useSupercluster from "use-supercluster";
import { MapIssueState, GeolocationUserState, MarkerComponentProps, MapDeliveryPointsState } from '../types/type';

const DEFAULT_ZOOM = 6;
const DEFAULT_COORDS = {
  lat: 39.368279,
  lng: -12.412793
} 
//@ts-ignore
export default ({
  sectionType,
  withDateIntervalFilter
}, {
  sectionType: String,
  withDateIntervalFilter: boolean
}) => {
  const filterState = useContext(FilterContext);
  const [modalIssue, setModalIssue] = useState({ show: false, data: null })
  const [modalDeliveryPoint, setModalDeliveryPoint] = useState({ show: false, data: null })
  //const geolocation = useGeolocation()
  const [issues, setIssues] = useState<[MapIssueState] | null>(null);
  const [deliveryPoints, setDeliveryPoints] = useState<MapDeliveryPointsState | any>(null);
  const [points, setPoints] = useState<any>([])
  const [bounds, setBounds] = useState<[number, number, number, number] | null>(null);
  const [zoom, setZoom] = useState(DEFAULT_ZOOM);
  const mapRef = useRef();
  const mapsRef = useRef(); 

  useEffect(() => {
    if (sectionType === "collected") {
      setPoints(
        issues ? issues.map((issue) => {
          const parentID = issue.TypeParentID && filterState.filterData && filterState.filterData.categoryData.find((data) => parseInt(issue.TypeParentID) === data.ID)
          return {
            "type": "Feature",
            "properties": {
              "cluster": false,
              "uuid": issue.UUID,
              "reporterName": issue.ReporterName,
              "date": issue.DateReported,
              "typeName": issue.IssueTypeName,
              "id": issue.IssueID,
              "parentTypeName": parentID ? parentID.Name : null
            },
            "geometry": { "type": "Point", "coordinates": [issue.GPS_LONG, issue.GPS_LAT] }
          }
        }) : []
      );
    } else {
      setPoints(
        deliveryPoints ? Object.keys(deliveryPoints).map((deliveryPointKey) => {
          return {
            "type": "Feature",
            "properties": {
              "cluster": false,
              "id": deliveryPoints[deliveryPointKey].DeliveryPointID,
              "name": deliveryPoints[deliveryPointKey].DeliveryPointName,
              "deliveredIssues": deliveryPoints[deliveryPointKey].IssuesID
            },
            "geometry": { "type": "Point", "coordinates": [deliveryPoints[deliveryPointKey].GPS_LONG, deliveryPoints[deliveryPointKey].GPS_LAT] }
          }
        }) : []
      );
    }
    
  }, [issues, deliveryPoints])

  const { clusters, supercluster } = useSupercluster({
    points,
    bounds,
    zoom,
    options: { radius: 75, maxZoom: 20 },
  });
  const [geolocationUser, setGeolocationUser] = useState<GeolocationUserState>(DEFAULT_COORDS);

  useEffect(() => {
    async function init() {
      let parseByTypeID: number[] = [];
      let parseByPortID: number[] = [];

      if (filterState.selectedPort && filterState.selectedPort !== "-" && filterState.selectedPort !== "0") { parseByPortID = [parseInt(filterState.selectedPort!)] }
      if (filterState.filterData && filterState.selectedCategory && filterState.selectedCategory !== "-" && filterState.selectedCategory !== "0") {
        parseByTypeID = filterState.filterData.typeData.filter((type) => {
          return type.ParentID === parseInt(filterState.selectedCategory!)
        }).map((type) => type.ID);
      }
      if (filterState.selectedType && filterState.selectedType !== "-" && filterState.selectedType !== "0") { parseByTypeID = [parseInt(filterState.selectedType!)] }
      const response = await fetch(process.env.REACT_APP_BACKEND_URL + (sectionType === "collected" ? `/kpi/issue-map` : `/kpi/issue-map-delivered-points`), {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          byTypeID: parseByTypeID,
          byPortID: parseByPortID || [],
          isDelivered: sectionType === "collected" ? false : true,
          startDate: withDateIntervalFilter ? filterState.selectedStartDate.toISOString().split("T")[0] : new Date(0).toISOString().split("T")[0],
          endDate: withDateIntervalFilter ? filterState.selectedEndDate.toISOString().split("T")[0] : new Date().toISOString().split("T")[0],
        })
      });

      const result = (await response.json()).results
      setIssues(result);
    
      let deliveryPoints = {}
      //Parse delivery points cooresponding to the issues
      for (let issue of result) {
        if(deliveryPoints[issue.DeliveryPointID]) {
          deliveryPoints[issue.DeliveryPointID].IssuesID.push(issue.IssueID)
        } else {
          deliveryPoints[issue.DeliveryPointID] = {
            DeliveryPointID: issue.DeliveryPointID,
            DeliveryPointName: issue.DeliveryPointName, 
            GPS_LAT: issue.Delivery_GPS_LAT,
            GPS_LONG: issue.Delivery_GPS_LONG,
            IssuesID: [issue.IssueID]
          }
        }
      }
      setDeliveryPoints(deliveryPoints)
      
      if (mapsRef.current && mapRef.current) {
        //@ts-ignore
        const latLng = new mapsRef!.current!.LatLng(DEFAULT_COORDS.lat, DEFAULT_COORDS.lng);
        //@ts-ignore
        mapRef!.current!.setZoom(DEFAULT_ZOOM)
        //@ts-ignore
        mapRef!.current!.panTo(latLng);
      }
    }
    init()
  }, [sectionType, filterState.selectedPort, filterState.selectedCategory, filterState.selectedType, filterState.selectedStartDate, filterState.selectedEndDate])

  /*useEffect(() => {
    if (geolocation.latitude && geolocation.longitude && !geolocation.error) {
      setGeolocationUser({ lat: geolocation.latitude, lng: geolocation.longitude })
    }
  }, [geolocation])
  */

  const loadIssueModal = () => {
    const controlButtonDiv = document.createElement('div');
    controlButtonDiv.setAttribute("id", "divModalIssue");

    ReactDOM.render(IssueModal(), controlButtonDiv);
    return controlButtonDiv
  }

  const loadDeliveryPointModal = () => {
    const controlButtonDiv = document.createElement('div');
    controlButtonDiv.setAttribute("id", "divModalDeliveryPoint");

    ReactDOM.render(DeliveryPointModal(), controlButtonDiv);
    return controlButtonDiv
  }

  const IssueModal = () =>
    <div className="modal fade" id="issueModal" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop={false}>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
        {
        modalIssue.data &&
        <Modal.Header>
          <Modal.Title>
            <span>{`${modalIssue.data.typeName ? modalIssue.data.typeName.charAt(0).toUpperCase() + modalIssue.data.typeName.slice(1) : " - "}`}</span>
            {
              modalIssue.data.parentTypeName &&
              <React.Fragment>
                <br />
                <span style={{ fontSize: "1rem", fontWeight: "normal" }}>{`${modalIssue.data.parentTypeName.charAt(0).toUpperCase() + modalIssue.data.parentTypeName.slice(1)}`}</span>
              </React.Fragment>
            }
          </Modal.Title>
          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </Modal.Header>
      }
       {
        modalIssue.data &&
        <Modal.Body>
          <Container>
            <Row>
              <Col>
                <Image style={{ maxHeight: "180px" }} thumbnail={true} src={process.env.REACT_APP_IMAGE_STORAGE_URL + `/${modalIssue.data.uuid}.jpeg`} onError={(ev) => {
                  //@ts-ignore
                  ev.target.src = require("../assets/nopicture.png").default;
                }} fluid />
              </Col>
              <Col style={{ padding: "0px", textAlign: "center", fontSize: "1rem", fontWeight: "normal" }}>
                {modalIssue.data.reporterName}<hr />
                {modalIssue.data.date.split("T")[0]}<br />
                {modalIssue.data.date.split("T")[1].split(".")[0]}
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      }
        </div>
      </div>
    </div>

  const DeliveryPointModal = () =>
    <div className="modal fade" id="deliveryPointModal" tabIndex={-1} role="dialog" aria-labelledby="ModalLabel" aria-hidden="true" data-backdrop={false}>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
        {
        modalDeliveryPoint.data &&
        <Modal.Header>
          <Modal.Title>
            <span>{`${modalDeliveryPoint.data.name}`}</span>
          </Modal.Title>
          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </Modal.Header>
      }
      {
        modalDeliveryPoint.data &&
        <Modal.Body>
          <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Imagem</th>
                  <th>Barco</th>
                  <th>Item</th>
                </tr>
              </thead>
              <tbody>
              {
            modalDeliveryPoint.data.deliveredIssues.map((deliveredIssue) => {
              const issueData = issues.find((issue) => issue.IssueID === deliveredIssue);
              if(issueData) {
                return (
                  <tr>
                    <td style={{textAlign: "center"}}>
                      <Image style={{ maxHeight: "90px" }} thumbnail={true} src={process.env.REACT_APP_IMAGE_STORAGE_URL + `/${issueData.UUID}.jpeg`} onError={(ev) => {
                        //@ts-ignore
                        ev.target.src = require("../assets/nopicture.png").default;
                      }} fluid />
                    </td>
                    <td style={{textAlign: "center", verticalAlign: "middle"}}>{issueData.ReporterName}</td>
                    <td style={{textAlign: "center", verticalAlign: "middle"}}>{issueData.IssueTypeName}</td>
                  </tr>
                )
              } else {
                <tr>
                </tr>
              }
            })
          }
                
              </tbody>
          </Table>

          
        </Modal.Body>
      }
        </div>
      </div>
    </div>
 
  useEffect(() => {
    if (modalIssue.data) {
      ReactDOM.render(
        IssueModal()
        , document.getElementById("divModalIssue"));
    }
  }, [modalIssue])

  useEffect(() => {
    if (modalDeliveryPoint.data) {
      ReactDOM.render(
        DeliveryPointModal()
        , document.getElementById("divModalDeliveryPoint"));
    }
  }, [modalDeliveryPoint])

  return (
    <div style={{ height: window.location.pathname === "/map" ? '100vh' : '50vh', width: '100%' }}>
      <GoogleMapReact
		key={sectionType}
        bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAP_APIKEY || "" }}
        defaultCenter={geolocationUser}
        defaultZoom={zoom}
        onGoogleApiLoaded={({ map, maps }) => {
          mapRef.current = map;
          mapsRef.current = maps;
          // @ts-ignore
          mapRef!.current.controls[mapsRef!.current.ControlPosition.TOP_CENTER].push(loadIssueModal());
          // @ts-ignore
          mapRef!.current.controls[mapsRef!.current.ControlPosition.TOP_CENTER].push(loadDeliveryPointModal());
        }}
        onChange={({ zoom, bounds }) => {
          setZoom(zoom);
          setBounds([
            bounds.nw.lng,
            bounds.se.lat,
            bounds.se.lng,
            bounds.nw.lat
          ]);
        }}
      >
        {
          clusters.map((cluster) => {
            const [longitude, latitude] = cluster.geometry.coordinates;
            const {
              cluster: isCluster,
              point_count: pointCount
            } = cluster.properties;

            if (isCluster) {
              return (
                <Marker
                  key={`cluster-${cluster.id}`}
                  lat={latitude}
                  lng={longitude}
                >
                  <div
                    style={{
                      width: `${25 + (pointCount / (issues ? issues.length : 1)) * 20}px`,
                      height: `${25 + (pointCount / (issues ? issues.length : 1)) * 20}px`,
                      color: "#fff",
                      background: "#1978c8",
                      borderRadius: "50%",
                      padding: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                    onClick={() => {
                      const expansionZoom = Math.min(
                        supercluster.getClusterExpansionZoom(cluster.id),
                        20
                      );
                      // @ts-ignore
                      mapRef && mapRef.current.setZoom(expansionZoom);
                      // @ts-ignore
                      mapRef && mapRef.current.panTo({ lat: latitude, lng: longitude });
                    }}
                  >
                    {pointCount}
                  </div>
                </Marker>
              )
            } else {
              return (
                <Marker
                  key={cluster.properties.id}
                  lat={latitude}
                  lng={longitude}
                  text={cluster.properties.reporterName}
                >
                  <div style={{
                    position: 'absolute',
                    width: "15px",
                    height: "15px",
                    left: "0px",
                    top: "0px",
                    //border: '2px solid #0000cc',
                    //borderRadius: 40,
                    //backgroundColor: '#3366ff',
                  }}
                    onClick={() => {
                      if(sectionType === "collected"){
                        setModalIssue({ show: true, data: cluster.properties })
                        //@ts-ignore
                        $('#issueModal').modal('show');
                      } else {
                        setModalDeliveryPoint({ show: true, data: cluster.properties })
                        //@ts-ignore
                        $('#deliveryPointModal').modal('show');
                      }
                    }}
                  >
                    <img src={sectionType === "collected" ? require("../assets/5888925dbc2fc2ef3a1860ad.png").default : require("../assets/yellow-pin.png").default } width="20px" />
                  </div>
                </Marker>
              )
            }
          })
        }
      </GoogleMapReact>
      {
        //<IssueModal2 modalIssue={modalIssue} setModalIssue={setModalIssue} />
      }
    </div>
  )
}

const Marker = ({ children }: MarkerComponentProps) => children;
